<div class="tire-lookup-dialog" [ngClass]="{ 'al-inventory': selectedTab === 0, 'online-order': selectedTab !== 0 }">
  <div class="tld-content">
    <!-- Tire Lookup Header -->
    <div class="tire-lookup-dialog-header p-0">
      <div class="flex-between-center p-3">
        <p class="m-0 font-bold" *ngIf="isOpenFromReplenishment">New Stock Order</p>
        <p class="m-0 font-bold" *ngIf="!isOpenFromReplenishment">{{ isQuickTireLookupEnabled ? dialogTitle : 'Add Tires to RO' }}</p>

        <span class="close-modal">
          <i class="fal fa-times" (click)="handleClose()"></i>
        </span>
      </div>

      <!-- Tire size selection -->
      <div class="tire-size-selection-wrapper h-auto flex-start-start width-100p">
        <div class="recommeded-sizes">
          <ng-container *ngIf="isOpenFromQuickTireLookup && isQuickTireLookupEnabled">
            <div class="recommended-size-heading w-auto pr-2 pt-1">Vehicle</div>
            <div class="pr-2 w-50" *ngIf="!vehicle?.name">
              <app-auto-complete
                id="lookup-vehicle"
                listId="lookup-vehicle-list"
                itemWidth="575px"
                theme="border"
                noRecordIcon=""
                noRecordText="No vehicle found. Please search by tire size instead"
                placeholder="Enter VIN, year, make or model"
                styleClassLabel="mb-0"
                [textTruncate]="true"
                [fontSize]="14"
                [suggestions]="vehicleSuggestions"
                [floatingLabel]="false"
                [autoFocus]="true"
                [isLoading]="isVehicleSearching"
                [value]="vehicleQuery"
                (appSelect)="onVehicleSelect($event)"
                (appCompletedMethod)="onSearchVehicle($event)"
                (appClear)="handleClearSearch()"
                scrollHeight="186px"
              >
                <ng-template let-item appTemplate="item">
                  <div class="width-100p font-14 p-2 flex-column" [hidden]="item?.isHeader">
                    <div class="flex-between-center">
                      <p class="m-0" [innerHTML]="item?.htmlName"></p>
                      <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate" [innerHTML]="item?.htmlLicensePlate"></p>
                    </div>

                    <div class="flex-between-center">
                      <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.htmlEngine"></p>
                      <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin" [innerHTML]="item?.htmlVin"></p>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </ng-container>
          <div class="pr-2" *ngIf="isQuickTireLookupEnabled && vehicle?.name">
            <div class="vehicle-selected flex-row flex-between-center width-250">
              <span class="text-truncate">
                <i class="fal fa-car font-18 font-400 font-primary pr-1"></i>
                <span class="font-16 font-700 font-primary">{{ vehicle?.name }}</span>
              </span>

              <i class="fal fa-times font-16 font-400 font-primary pointer ml-2" (click)="openConfirmationRemoveDialog()" *ngIf="isOpenFromQuickTireLookup && !isRunTireStorageFlow"></i>
            </div>
          </div>
          <ng-container *ngIf="!isOpenFromReplenishment">
            <div class="recommended-size-heading pt-1 w-auto" *ngIf="vehicle?.vehicleBaseId">Recommended:</div>

            <div class="recommended-size-pill-wrapper flex-start-center pt-1 pl-1" [ngClass]="{ 'pt-1': recommendedSizes?.length }">
              <div
                *ngFor="let recommendedSize of recommendedSizes; let itemIndex = index"
                class="flex-start-center recommended-size-pill"
                [ngClass]="{ selected: (recommendedSize.value || recommendedSize.label) === selectedTireSize }"
                (click)="$event.stopPropagation(); handleRecommendedSelection(recommendedSize.value || recommendedSize.label, true, recommendedSize)"
              >
                <span class="pill-text">{{ recommendedSize.label }}</span>
              </div>
              <i class="fal fa-spinner rotate font-20 ml-2" *ngIf="isLoading && !recommendedSizes?.length"></i>
              <div class="font-14 font-secondary mt-5px font-500" *ngIf="!isTireSizesLoading && !recommendedSizes?.length && vehicle?.vehicleBaseId">Not found any recommended sizes</div>
            </div>
          </ng-container>
          <ng-container *ngIf="isOpenFromReplenishment">
            <div class="recommended-size-heading w-auto pr-2 pt-1">Part Number</div>
            <div class="mr-2">
              <app-input
                placeholder="Enter part number"
                [autoFocus]="false"
                [fontSize]="14"
                theme="border"
                [selectTextOnFocus]="true"
                [value]="partNumberInput"
                (appChange)="getTireByPartNumber($event)"
              >
              </app-input>
            </div>
          </ng-container>
        </div>

        <div class="custom-sizes" *ngIf="isQTQAddOnEnable">
          <div class="custom-size-heading">Size</div>

          <div class="custom-size-dropdown-wrapper">
            <div class="custom-size mr-2">
              <app-input
                placeholder="Search width"
                [autoFocus]="tireSearchSizeFocus?.tireWidth"
                [fontSize]="14"
                theme="border"
                [selectTextOnFocus]="true"
                [allowDecimal]="true"
                [value]="selectedAttr?.tireWidth?._id"
                (appChange)="handleSizeSelectQTQ('tireWidth', $event)"
              >
              </app-input>
            </div>
            <span class="mr-2 border-left size-separator"></span>
            <div class="custom-size mr-2">
              <app-input
                placeholder="Search profile"
                [autoFocus]="tireSearchSizeFocus?.tireProfile"
                [fontSize]="14"
                theme="border"
                [selectTextOnFocus]="true"
                [allowDecimal]="true"
                [value]="selectedAttr?.tireProfile?._id"
                (appChange)="handleSizeSelectQTQ('tireProfile', $event)"
              >
              </app-input>
            </div>
            <span class="mr-2 border-left size-separator"></span>
            <div class="custom-size">
              <app-input
                placeholder="Search size"
                [autoFocus]="tireSearchSizeFocus?.tireSize"
                [fontSize]="14"
                theme="border"
                [selectTextOnFocus]="true"
                [allowDecimal]="true"
                [value]="selectedAttr?.tireSize?._id"
                (appChange)="handleSizeSelectQTQ('tireSize', $event)"
              >
              </app-input>
            </div>
          </div>
        </div>

        <div class="custom-sizes" *ngIf="!isQTQAddOnEnable">
          <div class="custom-size-heading">Size</div>

          <div class="custom-size-dropdown-wrapper">
            <div class="custom-size mr-2">
              <app-dropdown
                id="select-width"
                listId="select-width-list"
                field="_id"
                theme="border"
                label="Select width"
                scrollHeight="170px"
                [closeOnSelection]="true"
                [isDropdownIconVisible]="true"
                placeholder="Select width"
                [disabled]="false"
                [floatingLabel]="false"
                [fontSize]="14"
                [value]="selectedAttr?.tireWidth"
                [options]="tireWidths"
                [isLoading]="showLoaderOnDD"
                (appSelect)="handleSizeSelect('tireWidth', $event)"
              >
              </app-dropdown>
            </div>
            <span class="mr-2 border-left size-separator"></span>
            <div class="custom-size mr-2">
              <app-dropdown
                id="select-profile"
                listId="select-profile-list"
                field="_id"
                theme="border"
                scrollHeight="170px"
                label="Select profile"
                [closeOnSelection]="true"
                [isDropdownIconVisible]="true"
                placeholder="Select profile"
                [disabled]="false"
                [floatingLabel]="false"
                [fontSize]="14"
                [value]="selectedAttr?.tireProfile"
                [options]="tireProfiles"
                [isLoading]="showLoaderOnDD"
                (appSelect)="handleSizeSelect('tireProfile', $event)"
              >
              </app-dropdown>
            </div>
            <span class="mr-2 border-left size-separator"></span>
            <div class="custom-size">
              <app-dropdown
                id="select-size"
                listId="select-size-list"
                field="_id"
                theme="border"
                label="Select size"
                scrollHeight="170px"
                [closeOnSelection]="true"
                [isDropdownIconVisible]="true"
                placeholder="Select size"
                [disabled]="false"
                [floatingLabel]="false"
                [fontSize]="14"
                [value]="selectedAttr?.tireSize"
                [options]="tireSizes"
                [isLoading]="showLoaderOnDD"
                (appSelect)="handleSizeSelect('tireSize', $event)"
              >
              </app-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recommended sizes -->
    <div class="bg-white border-top p-2 tire-lookup-recommended-section w-100" *ngIf="isOpenFromReplenishment && vehicle?.vehicleBaseId">
      <div class="recommeded-sizes-replinishment">
        <div class="recommended-size-heading pt-1 w-auto">Recommended:</div>

        <div class="recommended-size-pill-wrapper flex-start-center pt-1 pl-1" [ngClass]="{ 'pt-1': recommendedSizes?.length }">
          <div
            *ngFor="let recommendedSize of recommendedSizes; let itemIndex = index"
            class="flex-start-center recommended-size-pill"
            [ngClass]="{ selected: (recommendedSize.value || recommendedSize.label) === selectedTireSize }"
            (click)="$event.stopPropagation(); handleRecommendedSelection(recommendedSize.value || recommendedSize.label, true, recommendedSize)"
          >
            <span class="pill-text">{{ recommendedSize.label }}</span>
          </div>
          <i class="fal fa-spinner rotate font-20 ml-2" *ngIf="isLoading && !recommendedSizes?.length"></i>
          <div class="font-14 font-secondary mt-5px font-500" *ngIf="!isTireSizesLoading && !recommendedSizes?.length && vehicle?.vehicleBaseId">Not found any recommended sizes</div>
        </div>
      </div>
    </div>

    <!-- Tire Lookup Body -->
    <div class="tire-lookup-dialog-body mt-0">
      <p-tabView class="tab-panel-underline tab-panel-estimates tab-panel-default" [(activeIndex)]="selectedTab" (onChange)="handleTabChange($event)">
        <!-- Inventory -->
        <p-tabPanel [selected]="selectedTab === 0" *ngIf="!isOpenFromReplenishment">
          <ng-template pTemplate="header">
            <p class="m-0 flex-start-center">
              <img src="assets/img/AL_Logo.svg" alt="AutoLeap Logo" class="mr-1" />
              <span>AL Inventory</span>
              <span *ngIf="selectedItemCount?.autoleap" class="pill ml-1">{{ selectedItemCount?.autoleap }}</span>
            </p>
          </ng-template>

          <ng-template pTemplate="content">
            <div class="lookup-body">
              <app-inventory-tire-lookup
                [isRunTireStorageFlow]="isRunTireStorageFlow"
                [selectedQty]="selectedQty"
                [isTabActive]="selectedTab === 0"
                [isTireSizesLoading]="isTireSizesLoading"
                [isOpenFromRO]="isOpenFromRO"
                [selectedTab]="selectedTab"
                [selectedTireSize]="isQTQAddOnEnable ? selectedRecommended : selectedTireSize"
                [tires]="inventoryTires"
                [defaultServiceTotal]="defaultServiceTotal"
                [hideCost]="hideCost"
                [setSelectedTax]="selectedTax"
                [taxAmtOnAdonService]="taxAmtOnAdonService"
                [isCartVisible]="isCartVisible"
                [emptyCart]="!recommendedSizes?.length"
                (appHandleSelectTire)="handleSelectTire($event)"
                (appSetTireSizeAttr)="setTireSizeAttr($event)"
                (updateSelectedItemCount)="handleUpdateSelectedItemCount($event.source, $event.count)"
                (appHandleAlTireValidation)="handleAlTireValidation($event)"
                (appOnAddCustomerAndVehicle)="handleAddCustomerAndVehicle($event)"
                (appOnSetGlobalCart)="setGlobalCart($event)"
              ></app-inventory-tire-lookup>
            </div>
          </ng-template>
        </p-tabPanel>

        <!-- TireHub -->
        <p-tabPanel *ngIf="isTireHubEnabled" [selected]="selectedTab === 1">
          <ng-template pTemplate="header">
            <p class="m-0 flex-start-center">
              <img src="assets/img/Tirehub_Logo.svg" alt="TireHub Logo" class="mr-1" />
              <span>TireHub</span>
              <span *ngIf="selectedItemCount?.tirehub" class="pill ml-1">{{ selectedItemCount?.tirehub }}</span>
            </p>
          </ng-template>

          <ng-template pTemplate="content">
            <div class="lookup-body">
              <app-tirehub-lookup
                [isRunTireStorageFlow]="isRunTireStorageFlow"
                [selectedQty]="selectedQty"
                [isTabActive]="selectedTab === 1"
                [isTireSizesLoading]="isTireSizesLoading"
                [tireHubSettings]="tireHubSettings"
                [setSelectedTax]="selectedTax"
                [setSelectedPricingMatrix]="selectedPricingMatrix"
                [taxAmtOnAdonService]="taxAmtOnAdonService"
                [globalCartItemList]="globalCartItemList"
                [globalCartCount]="globalCartCount"
                [defaultServiceTotal]="defaultServiceTotal"
                [hideCost]="hideCost"
                [selectedTab]="selectedTab"
                [tireHubSesssionId]="sessionId"
                [isCartVisible]="isCartVisible"
                [isEmptySizes]="isEmptySizes"
                [brands]="brands"
                [loadIndexes]="loadIndexes"
                [attrType]="attrType"
                [emptyCart]="!recommendedSizes?.length"
                [speedRatings]="speedRatings"
                [warehouses]="warehouses"
                [isOpenFromQuickTireLookup]="isOpenFromQuickTireLookup"
                [isOpenFromRO]="isOpenFromRO"
                (showLoader)="showLoaderOnDD = $event"
                [selectedTireSize]="isQTQAddOnEnable ? selectedRecommended : selectedTireSize"
                [selectedAttr]="selectedAttr"
                (appSetTireHubTireSizeAttr)="setTireSizeAttr($event)"
                (updateSelectedItemCount)="handleUpdateSelectedItemCount($event.source, $event.count)"
                (appOnAddCustomerAndVehicle)="handleAddCustomerAndVehicle($event)"
                (appOnSetGlobalCart)="setGlobalCart($event)"
                (appOnCalculatingShipping)="shippingLoader = $event?.shippingLoader; isShippingCalculating = $event?.isShippingCalculating"
              ></app-tirehub-lookup>
            </div>
          </ng-template>
        </p-tabPanel>

        <!-- TireConnect -->
        <p-tabPanel *ngIf="isTireConnectEnabled" [selected]="selectedTab === 2">
          <ng-template pTemplate="header">
            <p class="m-0 flex-start-center">
              <img src="assets/img/tireConnect-logo.png" alt="TireConnect Logo" class="mr-1" />
              <span>TireConnect</span>
              <span *ngIf="selectedItemCount?.tireConnect" class="pill ml-1">{{ selectedItemCount?.tireConnect }}</span>
            </p>
          </ng-template>

          <ng-template pTemplate="content">
            <div class="lookup-body">
              <app-tireconnect-lookup
                [isRunTireStorageFlow]="isRunTireStorageFlow"
                [selectedQty]="selectedQty"
                [isTabActive]="selectedTab === 2"
                [isTireSizesLoading]="isTireSizesLoading"
                [isOpenFromRO]="isOpenFromRO"
                [selectedTab]="selectedTab"
                [tireConnectSesssionId]="sessionId"
                [isCartVisible]="isCartVisible"
                [globalCartItemList]="globalCartItemList"
                [stockReplenishmentTireList]="stockReplenishmentTireList"
                [setSelectedTax]="selectedTax"
                [setSelectedPricingMatrix]="selectedPricingMatrix"
                [taxAmtOnAdonService]="taxAmtOnAdonService"
                [partNumber]="partNumberInput"
                [globalCartCount]="globalCartCount"
                [isOpenFromReplenishment]="isOpenFromReplenishment"
                [defaultServiceTotal]="defaultServiceTotal"
                [hideCost]="hideCost"
                [isEmptySizes]="isEmptySizes"
                [selectedTireSize]="selectedRecommended"
                [emptyCart]="!recommendedSizes?.length"
                [tireConnectSettings]="tireConnectSettings"
                [attrType]="attrType"
                [selectedAttr]="selectedAttr"
                [isOpenFromQuickTireLookup]="isOpenFromQuickTireLookup"
                (appSetTireSizeAttr)="setTireSizeAttr($event)"
                (showLoader)="showLoaderOnDD = $event"
                (updateSelectedItemCount)="handleUpdateSelectedItemCount($event.source, $event.count)"
                (appOnAddCustomerAndVehicle)="handleAddCustomerAndVehicle($event)"
                (appOnCreateInvetoryOrder)="handleCreateInvetoryOrder($event)"
                (appOnSetGlobalCart)="setGlobalCart($event)"
                (updatePartNumberInput)="partNumberInput = $event"
                (appOnCalculatingShipping)="shippingLoader = $event?.shippingLoader; isShippingCalculating = $event?.isShippingCalculating"
              ></app-tireconnect-lookup>
            </div>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
      <div *ngIf="isQTQAddOnEnable && isAdOnServicesLoads && isTaxesLoaded">
        <div class="flex-between-center position-absolute tire-qty-qtq">
          <div>
          <app-list-filter
            [options]="filterOptions"
            [multipleGenericFiltersKeys]="multipleGenericFiltersKeys"
            [multipleGenericFiltersObject]="multipleGenericFiltersObject"
            (filterChange)="filterChange($event)"
          >
          </app-list-filter>
          <!-- <app-dropdown
            id="fleet-pricing-matrix"
            listId="pricing-matrix-list"
            placeholder="Select part matrix"
            theme="border"
            field="name"
            [value]=""
            [fontSize]="14"
            [listItemFontSize]="13"
            [floatingLabel]="true"
            [options]="pricingMatrixcOptions"
            [isDropdownIconVisible]="true"
            (appSelect)="handlePricingMatrixChange($event)"
          >
          </app-dropdown> -->
        </div>
          

          <div class="flex-row">
            <span class="cart-btns">
              <button
                class="btn btn-autoleap btn-eye-slash flex-center-center"
                tooltipPosition="top"
                [pTooltip]="hideCost ? 'Service Writer preview' : 'Customer Preview'"
                (click)="hideCost = !hideCost"
              >
                <i class="fa" [ngClass]="hideCost ? 'fa fa-eye' : 'fa-eye-slash'"></i>
              </button>
            </span>

            <button class="btn btn-autoleap btn-submit ml-2" (click)="isCartVisible = !isCartVisible" [hidden]="isOpenFromRO && selectedTab === 0">
              <i class="far fa-shopping-cart pr-1"></i>
              cart ({{ globalCartCount }})
            </button>
          </div>
        </div>
      </div>
      <ng-container *ngIf="isQTQAddOnEnable && isAdOnServicesLoads && isTaxesLoaded">
        <app-tire-global-cart
          [ngClass]="{ 'display-none': !isCartVisible }"
          [adOnServicesObj]="adOnServicesObj"
          [setSelectedTax]="selectedTax"
          [isPassThroughTaxEnable]="isPassThroughTaxEnable"
          [isTireStorage2Enabled]="isTireStorage2Enabled"
          [selectedTab]="selectedTab"
          [defaultAdonService]="defaultAdonService"
          [globalCartItemList]="globalCartItemList"
          [globalCartOrderTotal]="globalCartOrderTotal"
          [isAllCountAvailable]="isAllCountAvailable"
          [hideCost]="hideCost"
          [setSelectedQty]="selectedQty"
          [estimateServices]="services"
          [isEditMode]="isEditMode"
          [roCode]="roCode"
          [isOpenFromRO]="isOpenFromRO"
          [isOpenFromQuickTireLookup]="isOpenFromQuickTireLookup"
          [isSubmitting]="isSubmitting"
          [shippingLoader]="shippingLoader"
          [isShippingCalculating]="isShippingCalculating"
          [isRunTireStorageFlow]="isRunTireStorageFlow"
          (closeCart)="isCartVisible = $event"
          (appOnSave)="handleGlobalCartAction($event)"
          (appOnAdonServiceTotalChange)="handleAdonServicetotalChange($event)"
          (appOnAddCustomerAndVehicle)="handleGlobalCartAction($event)"
        >
        </app-tire-global-cart>
      </ng-container>
    </div>
  </div>

  <!-- Tire Lookup Footer -->
  <div *ngIf="selectedTab === 0 && !isOpenFromQuickTireLookup" class="tire-lookup-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>

    <button class="btn btn-primary btn-submit" [ngClass]="{ disable: !isTireSelected }" [disabled]="!isTireSelected" (click)="handleSubmit()">Add to RO</button>
  </div>
</div>
